// Utility to read selected metrics
export const getMetricsFromList = (arr: {
  [x: string]: {
    show: boolean;
    metric: any;
  };
}) => {
  const result = [];
  for (const key in arr) {
    if (arr[key].show === true) result.push(arr[key].metric);
  }
  return result;
};

// parsing to remove legacy format
const LEGACY_TAGS_PREFIX = 'tags.';
export const getMetricTable = (metricList) => {
  const updatedMetricColumns = metricList.map((metric) => {
    return { metric: metric.replace(LEGACY_TAGS_PREFIX, ''), show: true };
  });
  return updatedMetricColumns;
};
